import { numOrNull } from './buildPoolEngineInput';
import { readsShare, shareBaseFor } from './poolShareStrategy';
import { describeSalesReached, formatSharePercent, poolShareOfGross } from '../../../shared/poolShareOfGross';

// O-4755. Agents write support deals as a share of GROSS ("the opener gets 10%
// of the door"), but in Pool mode a member's percentage is a share of the POOL.
// These convert between the two so a booker stops doing the arithmetic by hand.

// A share of gross expressed as the equivalent share of the pool.
//
// If the pool is E% of gross, then X% of gross is (X / E) * 100 percent of the
// pool — e.g. a 70% pool turns "10% of gross" into ~14.29% of the pool. A result
// above 100 is meaningful rather than an error: it means the requested cut is
// larger than the whole pool, which the caller surfaces.
// numOrNull rather than Number(): an empty input coerces to 0, which would show
// a confident "0% of pool" for a field the booker has not filled in yet.
export const grossPercentToPoolPercent = (grossPercent, poolSharePercent) => {
  const target = numOrNull(grossPercent);
  if (target === null) return null;
  // A share of gross below zero is not a deal anyone is writing; answering it
  // with a confident negative percentage reads as though the tool understood.
  if (!(target >= 0)) return null;
  if (!(poolSharePercent > 0)) return null;

  return (target / poolSharePercent) * 100;
};

const poolPercentToGrossPercent = (poolPercent, poolSharePercent) => {
  const share = numOrNull(poolPercent);
  if (share === null) return null;
  if (!(share >= 0)) return null;
  if (!(poolSharePercent > 0)) return null;

  return (share * poolSharePercent) / 100;
};

const equivalentShare = (strategy, share, poolSharePercent) => {
  const base = shareBaseFor(strategy);
  if (base === 'pool') return { base: 'gross', percent: poolPercentToGrossPercent(share, poolSharePercent) };
  if (base === 'gross') return { base: 'pool', percent: grossPercentToPoolPercent(share, poolSharePercent) };
  return null;
};

export const describeShareEquivalent = (strategy, share, earnings) => {
  if (!readsShare(strategy)) return null;
  const equivalent = equivalentShare(strategy, share, poolShareOfGross(earnings));
  if (equivalent === null) return null;
  if (equivalent.percent === null) return null;
  return `= ${formatSharePercent(equivalent.percent)} of ${equivalent.base} ${describeSalesReached(earnings)}`;
};
